import React, { Component } from 'react';

import { Row, Col, InputGroup } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
/**
import CommonCheckbox from '../components/CommonCheckbox';
import CommonRadio from '../components/CommonRadio';
*/
import CommonButton from '../components/CommonButton';

class SearchEB03DataCourse extends Component {

    render = () => {
        
        let props = this.props;

        let { onInputChange, onSearch } = props;

        let { Action, Searchs, InputGroup: InputGroups, Masterbase, Operation } = props;

        let { course_eb_02_name, official_course_code, receiver, tax_id, course_status } = Searchs; 

        if(Operation.Search !== true) return null;

        return (
            <>
                <Row>
                    <Col md={6}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text className="input-group-text">{official_course_code.label}</InputGroup.Text>
                            <CommonInput
                                element="Searchs"
                                input={official_course_code}
                                hr={false}
                                callback={(e, element) => onInputChange(e, element)} 
                            />
                        </InputGroup>
                    </Col>   
                    <Col md={6}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text className="input-group-text">{course_eb_02_name.label}</InputGroup.Text>
                            <CommonInput
                                element="Searchs"
                                input={course_eb_02_name}
                                hr={false}
                                callback={(e, element) => onInputChange(e, element)} 
                            />
                        </InputGroup>
                    </Col>                       
                </Row>
                <Row>
                    <Col md={3}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text className="input-group-text">{receiver.label}</InputGroup.Text>
                            <CommonInput
                                element="Searchs"
                                input={receiver}
                                hr={false}
                                callback={(e, element) => onInputChange(e, element)} 
                            />
                        </InputGroup>
                    </Col> 
                    <Col md={3}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text className="input-group-text">{tax_id.label}</InputGroup.Text>
                            <CommonInput
                                element="Searchs"
                                input={tax_id}
                                hr={false}
                                callback={(e, element) => onInputChange(e, element)} 
                            />
                        </InputGroup>
                    </Col> 
                    <Col md={3}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text className="input-group-text">{course_status.label}</InputGroup.Text>
                            <CommonSelect
                                element="Searchs"
                                input={course_status}
                                option={{source: 'options', section: 'status', item: 'eb02_course_status'}}
                                hr={false}
                                callback={(e, element) => onInputChange(e, element)} 
                            />
                        </InputGroup>
                    </Col>                     
                    <Col md={3}>
                        <CommonButton 
                            task="search" 
                            disabled={Action.Loading.search ? true : false}
                            callback={(e) => onSearch(e)} 
                        />
                    </Col>                     
                </Row>               
            </>
        )
    }
}

export default SearchEB03DataCourse;